module.exports = __webpack_public_path__ + "static/media/red-flag.9a60ef04.svg";